import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Dropdown, Modal, ModalContentWrapper } from "components";
import { KeyRound, LogOut } from "lucide-react";
import { AuthenticationService } from "../../authentication/AuthenticationService";
import { ChangePasswordForm } from "../../pages/account/ChangePasswordForm";

const routeTitleMap: Record<string, string> = {
  "/": "Dashboard",
  "/dashboard": "Dashboard",
  "/team": "Team",
  "/support": "Support",
};

const getTitleFromPath = (pathname: string): string => {
  if (routeTitleMap[pathname]) return routeTitleMap[pathname];
  const parts = pathname.split("/").filter(Boolean);
  if (parts.length === 0) return "Overview";
  const last = parts[parts.length - 1];
  return last.charAt(0).toUpperCase() + last.slice(1);
};

const Topbar: React.FC = () => {
  const location = useLocation();
  const title = getTitleFromPath(location.pathname);
  const authenticationService = new AuthenticationService();
  const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false);

  const email = AuthenticationService.getEmail();
  const displayName = email ? (email.split("@")[0] || email) : "User";
  const initial = (displayName?.[0] || "U").toUpperCase();

  const handleLogout = () => {
    authenticationService.logout();
  };

  return (
    <div className="mx-auto w-full max-w-[1600px] h-14 px-6 flex items-center justify-between bg-white/80 backdrop-blur supports-[backdrop-filter]:bg-white/60 rounded-2xl ring-1 ring-vGray200 shadow-sm">
      <div className="flex items-center gap-3">
        <h2 className="text-[16px] font-semibold text-vTextBase">{title}</h2>
      </div>
      <div className="flex items-center gap-4">
        <Dropdown
          trigger={
            <button
              className="flex items-center gap-2 rounded-md px-2 py-1 hover:bg-vGray100 focus:outline-none focus:ring-2 focus:ring-partnerPrimary"
              aria-label="User menu"
              tabIndex={0}
            >
              <span className="text-sm text-vTextBase">{displayName}</span>
              <span className="w-8 h-8 rounded-full bg-[#E5E7EB] text-[#111827] flex items-center justify-center text-sm font-semibold">
                {initial}
              </span>
            </button>
          }
          items={[
            {
              label: "Change password",
              icon: KeyRound,
              onClick: () => setIsChangePasswordOpen(true),
            },
            { label: "Logout", icon: LogOut, onClick: handleLogout },
          ]}
        />
      </div>

      <Modal
        title="Change Password"
        isOpen={isChangePasswordOpen}
        onClose={() => setIsChangePasswordOpen(false)}
        closeWhenClickOutside={false}
      >
        <ModalContentWrapper>
          <ChangePasswordForm onClose={() => setIsChangePasswordOpen(false)} />
        </ModalContentWrapper>
      </Modal>
    </div>
  );
};

export default Topbar;
